<template>
  <div>
    <basic-container class="wel-container">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="dashboard member" @click="toMemberList">
            <div class="title">用户</div>
            <div class="count">{{memberCount}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="dashboard post" @click="toPostList">
            <div class="title">帖子</div>
            <div class="count">{{postCount}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="dashboard circle" @click="toCommentList">
            <div class="title">评论</div>
            <div class="count">{{commentCount}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="line">
        <el-col :span="8">
          <div class="dashboard column" @click="toYesterdayMemberList">
            <div class="title">昨日新用户</div>
            <div class="count">{{yesterdayMemberCount}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="dashboard essay" @click="toYesterdayPostList">
            <div class="title">昨日发帖</div>
            <div class="count">{{yesterdayPostCount}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="dashboard news" @click="toYesterdayCommentList">
            <div class="title">昨日评论</div>
            <div class="count">{{yesterdayCommentCount}}</div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="line">
        <el-col :span="8">
          <div class="dashboard visit" @click="toYesterdayMemberList">
            <div class="title">本月访问人数</div>
            <div class="count">{{currentMonthVisitCount}}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="dashboard lastVisit" @click="toYesterdayPostList">
            <div class="title">上月访问人数</div>
            <div class="count">{{lastMonthVisitCount}}</div>
          </div>
        </el-col>
      </el-row>
    </basic-container>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import { getMemberTotal, getMonthVisitCount } from '@/api/admin/member'
  import { getCommentTotal } from '@/api/post/comment'
  import { getPostTotal, getYesterdayStatistics } from '@/api/post/post'
  import { dateFormat } from '@/util/date'
  import moment, { months } from 'moment';
  import MemberTypeEnum from '@/common/enums/MemberTypeEnum'

  const initPage = vm => {
    getMemberTotal().then(response => {
      vm.memberCount = response.data.data
    }).catch(error => {
      console.error(error)
      vm.$message({
        message: '查询用户总数失败',
        type: 'error'
      })
    });

    getCommentTotal().then(response => {
      vm.commentCount = response.data.data
    }).catch(error => {
      console.error(error)
      vm.$message({
        message: '查询评论总数失败',
        type: 'error'
      })
    });

    getPostTotal().then(response => {
      vm.postCount = response.data.data
    }).catch(error => {
      console.error(error)
      vm.$message({
        message: '查询帖子总数失败',
        type: 'error'
      })
    });

    getYesterdayStatistics().then(response => {
      vm.yesterdayMemberCount = response.data.data.yesterdayMemberCount;
      vm.yesterdayPostCount = response.data.data.yesterdayPostCount;
      vm.yesterdayCommentCount = response.data.data.yesterdayCommentCount;
    }).catch(error => {
      vm.$message({
        message: '获取昨日数据失败',
        type: 'error'
      })
    });

    getMonthVisitCount({
        months: [moment().startOf('month').format('YYYY-MM-DD'), moment().startOf('month').subtract(1,'months').format('YYYY-MM-DD')]
    }).then(response => {
      vm.currentMonthVisitCount = response.data.data.currentMonth;
      vm.lastMonthVisitCount = response.data.data.lastMonth;
    }).catch(error => {
      vm.$message({
        message: '获取访问数据失败',
        type: 'error'
      })
    });
  }

  export default {
    name: 'wel',
    data() {
      return {
        memberCount: 0,
        commentCount: 0,
        postCount: 0,
        yesterdayMemberCount: 0,
        yesterdayPostCount: 0,
        yesterdayCommentCount: 0,
        currentMonthVisitCount: 0,
        lastMonthVisitCount: 0 
      }
    },
    computed: {
      ...mapGetters(['website'])
    },
    mounted () {
      initPage(this)
    },
    methods: {
      toMemberList () {
        // this.$router.push({path: '/member/member'})
      },
      toCommentList () {
        // this.$router.push({path: '/post/comment'})
      },
      toPostList () {
        // this.$router.push({path: '/post/posts'})
      },
      toYesterdayMemberList () {
        // this.$router.push({path: '/member/member', query: {date: this.getYesterdayTime()}})
      },
      toYesterdayCommentList () {
        // this.$router.push({path: '/post/comment', query: {date: this.getYesterdayTime()}})
      },
      toYesterdayPostList () {
        // this.$router.push({path: '/post/posts', query: {date: this.getYesterdayTime()}})
      },
      getYesterdayTime() {
        let yesterday = new Date(new Date().getTime() - 24 * 60 * 60 * 1000).toLocaleDateString();
        let date = new Date(yesterday);
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      }
    }
  }
</script>

<style scoped="scoped" lang="scss">
.wel-container {
  .line {
    margin-top: 50px;
  }
  .dashboard {
    border-width: 2px;
    border-style: solid;
    // cursor: pointer;
    margin-left: 5px;
    margin-right: 5px;
    text-align: center;

    .title {
      color: white;
      font-size: 28px;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .count {
      background-color: white;
      font-size: 44px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
  .member {
    background-color: #6eacf5;
    border-color: #6eacf5;
  }
  .circle {
    background-color: #fa7070;
    border-color: #fa7070;
  }
  .post {
    background-color: #fdbc2e;
    border-color: #fdbc2e;
  }
  .column {
    background-color: #fc946f;
    border-color: #fc946f;
  }
  .essay {
    background-color: #42bfeb;
    border-color: #42bfeb;
  }
  .news {
    background-color: #386680;
    border-color: #386680;
  }
  .visit {
    background-color: #62cc86;
    border-color: #62cc86;
  }
  .lastVisit {
    background-color: #4ec5c5;
    border-color: #4ec5c5;
  }
}
</style>
